export default function anonymous(props
/*``*/) {
var out='<div data-hook="time-control" class="'+(props.styles.timeWrapper)+' '+(props.themeStyles.timeText)+'"> <span data-hook="current-time-indicator" class="'+(props.styles.time)+'"> </span> <span data-hook="duration-time-indicator" class="'+(props.styles.time)+' '+(props.styles.duration)+'"> </span></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/controls/time/templates/time.dot
// module id = 223
// module chunks = 0 1 2 3 4